import React, { useEffect, useRef, useState } from 'react'
import { useLocation, Link } from "react-router-dom";
import '../Styles/App.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import GoogleTranslate from "../../GoogleTranslate"



export default function Header() {

    const [isScrolled, setIsScrolled] = useState(false);
    const [isOpentoggle, setOpentoggle] = useState(false);
    const [isToggleLogin, setToggleLogin] = useState(false);
    const [isToggleLogout, setToggleLogout] = useState(false);
    const [email, setEmail] = useState('');

    const navigate = useNavigate();

    const dropdownRef = useRef(null);
    const buttonRef = useRef(null);
    const chooseRef = useRef(null);
    const barRef = useRef(null);

    let PlayerToken = sessionStorage.getItem('player_token')
    let ClubToken = sessionStorage.getItem('club_token')

    const checkTokenValidity = (tokenKey) => {
        const token = sessionStorage.getItem(tokenKey);
        if (!token) return null;
        try {
            const decoded = jwtDecode(token);
            const currentTime = Math.floor(Date.now() / 1000);
            if (decoded.exp < currentTime) {
                sessionStorage.removeItem("player_token");
                sessionStorage.removeItem("club_token");
                return null;
            }
            return decoded.email;
        } catch (error) {
            return null;
        }
    };

    useEffect(() => {
        const userEmail = checkTokenValidity("player_token") || checkTokenValidity("club_token");
        setEmail(userEmail);
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        }
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const handletoggle = () => {
        setOpentoggle(!isOpentoggle)
    }

    const handletogglelogin = () => {
        setToggleLogin(!isToggleLogin)
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpentoggle, isToggleLogin]);

    const handleClickOutside = (event) => {
        if (
            isOpentoggle &&
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target) &&
            buttonRef.current &&
            !buttonRef.current.contains(event.target)
        ) {
            setOpentoggle(false);
        }
        if (
            isToggleLogin &&
            chooseRef.current &&
            !chooseRef.current.contains(event.target) &&
            barRef.current &&
            !barRef.current.contains(event.target)
        ) {
            setToggleLogin(false);
        }
    };

    const location = useLocation();
    const [active, setActive] = useState(location.pathname);

    const menuItems = [
        { name: "Home", path: "/" },
        { name: "About us", path: "/about" },
        { name: "Marketplace", path: "/auction" },
        { name: "My DNA", path: "/my-dna" },
        { name: "Fundraising", path: "/fundraise" },
    ];

    if (PlayerToken) {
        menuItems.splice(1, 0, { name: "Dashboard", path: "/user/dashboard" });
    } else if (ClubToken) {
        menuItems.splice(1, 0, { name: "Dashboard", path: "/club/dashboard" });
    }

    return (
        <header>
            <nav className={`md:fixed left-0 top-0 right-0 z-50 flex items-center px-4 py-4 lg:py-5 lg:px-10 font-poppins ${isScrolled ? 'backdrop-blur-sm ' : ''}`}>
                <div className='flex items-center justify-between w-[100%]'>
                    <div className='w-[50%] md:w-[25%] lg:w-[15%]'>
                        <img onClick={() => { navigate('/') }} src='/assets/logo/GLX_NEW_WT BG_Low.png'
                            className=' cursor-pointer'
                        ></img>
                    </div>
                    <div className='w-[85%] hidden lg:block'>
                        <div className='flex w-[100%]'>
                            <div className='w-[75%] header-gap text-white uppercase text-nowrap text-sm 2xl:text-base font-semibold flex justify-center items-center gap-16 '>
                                {menuItems.map((item) => (
                                    <a
                                        key={item.path}
                                        href={item.path}
                                        className="group relative"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            if (item.name === "Dashboard") {
                                                if (PlayerToken) {
                                                    navigate('/user/dashboard');
                                                } else if (ClubToken) {
                                                    navigate('/club/dashboard');
                                                }
                                            } else {
                                                navigate(item.path);
                                            }
                                        }}
                                    >
                                        <span className={`group-hover:text-white ${active === item.path ? "text-white font-bold" : "text-white/90"}`}>
                                            {item.name}
                                        </span>
                                        <div className={`absolute bottom-0 left-0 w-0 h-0.5 bg-white transition-all duration-300 group-hover:w-full ${active === item.path ? "w-full" : ""}`}></div>
                                    </a>
                                ))}
                            </div>

                            <div className='w-[25%] flex gap-5 items-center justify-end relative'>
                                <GoogleTranslate />

                                <div className='relative group'>
                                    {!PlayerToken && !ClubToken ?
                                        (
                                            <button
                                                className='flex border border-white rounded-full px-4 items-center py-2 text-xs 2xl:text-base border-2 font-bold text-white cursor-pointer transition-all duration-300 hover:shadow-[0_0_14px_rgba(255,255,255,0.8)]'
                                                onClick={() => { setToggleLogin(!isToggleLogin) }}
                                                ref={barRef}>
                                                Login <FontAwesomeIcon icon={faChevronDown} className='ml-2' />
                                            </button>
                                        )
                                        : (
                                            <button
                                                className='flex border border-white rounded-full px-4 items-center py-2 text-xs 2xl:text-base border-2 font-bold text-white cursor-pointer transition-all duration-300 hover:shadow-[0_0_14px_rgba(255,255,255,0.8)]'
                                                onClick={() => { setToggleLogout(!isToggleLogout) }}
                                            >
                                                {email.substring(0, 7)}...
                                            </button>
                                        )
                                    }
                                    {isToggleLogin && (
                                        <div className='absolute right-0 top-14' data-aos='fade-up' data-aos-duration='500' ref={chooseRef} style={{ zIndex: 2 }}>
                                            <div className='text-sm 2xl:text-base text-white bg-black capitalize font-bold duration-500 flex flex-col gap-1 border border-white/20 rounded-lg text-center text-nowrap px-5 py-3'>
                                                <a href='/player/login'>Player Login</a>
                                                <a href='/club/login'>Club Login</a>
                                            </div>
                                        </div>
                                    )}
                                    {isToggleLogout && (
                                        <div className='absolute right-0 top-14' data-aos='fade-up' data-aos-duration='500' ref={chooseRef} style={{ zIndex: 2 }}>
                                            <div className='text-sm 2xl:text-base text-white flex flex-col cursor-pointer bg-black capitalize font-bold duration-500 gap-1 border border-white/20 rounded-lg text-center text-nowrap px-5 py-3'>
                                                {/* <a ref={barRef} onClick={() => { PlayerToken ? navigate('/user/dashboard') : navigate('/club/dashboard'); setToggleLogout(false); }}>Dashboard</a> */}
                                                <div>
                                                    <a ref={barRef} onClick={() => { sessionStorage.removeItem('player_token'); sessionStorage.removeItem('club_token'); window.location.href = '/'; setToggleLogout(false); }}>Logout</a>
                                                    <FontAwesomeIcon icon={faRightFromBracket} className='ml-2' />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='block lg:hidden'>
                        <div className='flex justify-end pb-2'>
                            <button className='flex flex-col gap-[2px] relative' onClick={handletoggle} ref={buttonRef}>
                                <div className='w-5 h-[2px] bg-white rounded'></div>
                                <div className='w-4 h-[2px] bg-white rounded ml-auto'></div>
                                <div className='w-3 h-[2px] bg-white rounded ml-auto'></div>
                            </button>
                        </div>
                    </div>
                    {isOpentoggle && (
                        <div className='header-drop-down text-black z-10 text-nowrap absolute right-5 mt-2 top-14' ref={dropdownRef}>
                            <div className='flex flex-col gap-2 bg-black text-white text-center rounded-lg border border-white/20 p-5 uppercase'>
                                {menuItems.map((item) => (
                                    <Link key={item.path} to={item.path} className="group relative" onClick={() => setActive(item.path)}>
                                        <span className={`${active === item.path ? "text-white font-bold" : "text-white/90"}`}>
                                            {item.name}
                                        </span>
                                    </Link>
                                ))}
                                <div className=' flex items-center justify-center'>
                                    <div className='relative group'>
                                        {!PlayerToken && !ClubToken ?
                                            (
                                                <button
                                                    className='flex border border-white rounded-full px-4 items-center py-2 text-xs 2xl:text-base border-2 font-bold text-white cursor-pointer transition-all duration-300 hover:shadow-[0_0_14px_rgba(255,255,255,0.8)]'
                                                    onClick={() => { setToggleLogin(!isToggleLogin) }}
                                                    ref={barRef}>
                                                    Login <FontAwesomeIcon icon={faChevronDown} className='ml-2' />
                                                </button>
                                            )
                                            : (
                                                <button
                                                    className='flex border border-white rounded-full px-4 items-center py-2 text-xs 2xl:text-base border-2 font-bold text-white cursor-pointer transition-all duration-300 hover:shadow-[0_0_14px_rgba(255,255,255,0.8)]'
                                                    onClick={() => { setToggleLogout(!isToggleLogout) }}
                                                >
                                                    {email.substring(0, 7)}...
                                                </button>
                                            )
                                        }
                                    </div>
                                </div>
                                {isToggleLogin && (
                                    <div className='absolute right-0 top-60' data-aos='fade-up' data-aos-duration='500' ref={chooseRef} style={{ zIndex: 2 }}>
                                        <div className='text-sm 2xl:text-base text-white bg-black capitalize font-bold duration-500 flex flex-col gap-1 border border-white/20 rounded-lg text-center text-nowrap px-5 py-3'>
                                            <a href='/player/login'>Player Login</a>
                                            <a href='/club/login'>Club Login</a>
                                        </div>
                                    </div>
                                )}
                                {isToggleLogout && (
                                    <div className='absolute right-4 top-60' data-aos='fade-up' data-aos-duration='500' ref={chooseRef} style={{ zIndex: 2 }}>
                                        <div className='text-sm 2xl:text-base text-white flex flex-col cursor-pointer bg-black capitalize font-bold duration-500 gap-1 border border-white/20 rounded-lg text-center text-nowrap px-5 py-3'>
                                            {/* <a ref={barRef} onClick={() => { PlayerToken ? navigate('/user/dashboard') : navigate('/club/dashboard'); setToggleLogout(false); }}>Dashboard</a> */}
                                            <div>
                                                <a ref={barRef} onClick={() => { sessionStorage.removeItem('player_token'); sessionStorage.removeItem('club_token'); window.location.href = '/'; setToggleLogout(false); }}>Logout</a>
                                                <FontAwesomeIcon icon={faRightFromBracket} className='ml-2' />
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </nav>
        </header>
    )
}
